import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import moment from 'moment';
import alerts from "../services/Alerts";
import trans from "../services/Translator";
import userSettings from "../services/UserSettings";
const MAINTENANCE_URL = 'https://status.astina.ch/maintenance';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MaintenanceNotice',
    setup(__props) {
        const userSettings_ = userSettings('paloma-ui.maintenance-notice');
        window.setTimeout(checkMaintenance, 3000); // 3 seconds
        const checkInterval = window.setInterval(checkMaintenance, 300000); // 5 minutes
        function checkMaintenance() {
            const req = new XMLHttpRequest();
            req.onreadystatechange = () => {
                if (req.readyState !== XMLHttpRequest.DONE
                    || req.status !== 200
                    || !req.responseText) {
                    return;
                }
                const messages = JSON.parse(req.responseText) || [];
                messages
                    .filter(isVisible)
                    .forEach(displayMessage);
                window.clearInterval(checkInterval);
            };
            const appUrl = window.location.href;
            const url = MAINTENANCE_URL + '?url=' + encodeURIComponent(appUrl);
            req.open('GET', url, true);
            req.send();
        }
        function displayMessage(message) {
            let text = message.message || '';
            const infos = [];
            if (message.start) {
                const start = moment(message.startedAt);
                infos.push(start.format('DD.MM.YYYY HH:mm'));
            }
            if (message.duration) {
                let duration = message.duration + ' min.';
                if (message.duration >= 120) {
                    duration = Math.round(message.duration / 60) + 'h';
                }
                infos.push('~' + duration);
            }
            if (infos.length > 0) {
                text = text + '\n(' + infos.join(', ') + ')';
            }
            const imminent = isImminent(message);
            alerts.notify(imminent ? 'warning' : 'info', trans('maintenance_notice'), text, {
                closable: !imminent,
                timeout: imminent ? undefined : 60 * 1000,
                onDismiss: () => setDismissed(message),
            });
        }
        function isVisible(message) {
            return message.active && !isDismissed(message);
        }
        function isImminent(message) {
            if (!message.start) {
                return true;
            }
            const start = new Date(message.start * 1000);
            const diff = start.getTime() - new Date().getTime();
            return diff < 10 * 60 * 1000; // 10 minutes
        }
        function setDismissed(message) {
            const settings = userSettings_.get({ dismissed: [] });
            if (settings.dismissed.indexOf(message.id) === -1) {
                settings.dismissed.push(message.id);
                userSettings_.set(settings);
            }
        }
        function isDismissed(message) {
            const settings = userSettings_.get({ dismissed: [] });
            return settings.dismissed.indexOf(message.id) !== -1;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div"));
        };
    }
});
